import React, { Component } from 'react'
import {
    Link as BaseLink,
    NavLink as BaseNavLink,
} from 'react-router-dom'
import Configurator from '../../../configurator'

/**
 * @description Base react link definition
 *      USAGE
 *          <Link
 *              *** PROPS ***
 *          >
 *             Here we go
 *          </Button>
 *
 *      PROPS - all props are optional
 *          to          - to attribute will be replaced with right language code
 *          type        - NavLink|null - if is NavLink, return NavLink instead of Link
 *          restProps   - all other props available as React says
 *
 */
export default class Link extends Configurator {

    componentWillUnmount() {
        const { scrollToTop } = this.props

        if(scrollToTop !== false) {
            this.scrollTop()
        }
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            type,
            to,
            children,
            scrollToTop,
            ...restProps
        } = this.props

        if (type === 'NavLink') {
            return (
                <BaseNavLink to={to} {...restProps}>
                    {children}
                </BaseNavLink>
            )
        }

        return (
            <BaseLink to={to} {...restProps}>
                {children}
            </BaseLink>
        )
    }

}

/**
 * Smaller alias for NavLink
 */
export class NavLink extends Component {
    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return (
            <Link {...this.props} type="NavLink" />
        )
    }
}
